import { fetchAddresses, getCurrentAddress, setAddress, setDefaultAddress } from './helpers';

export default Object.freeze({
    fetchAddresses,
    setDefaultAddress,
    getCurrentAddress,
    setAddress,
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/address/actions.js